import { FC, useState, useEffect } from "react";
import imageEmail from "../../../assets/images/emailImage.png";
import "./index.css";

import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import api from "../../../services/api";
import { usePluginspace } from "../../../hooks/usePluginspace";
import { Loading } from "../../../components/Loading";
import { useAppConfig } from "../../../hooks/useAppConfig";

const ResetPassword: FC = () => {
  const navigate = useNavigate();
  const { pluginspace_id } = useParams();
  const { getToken } = usePluginspace();
  const [loading, setLoading] = useState(false);

  const [password, setPassword] = useState("");
  const [passwordAgain, setPasswordAgain] = useState("");

  const { getAppConfig } = useAppConfig();
  const [primaryColor, setPrimaryColor] = useState("#078BD8");

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const configData = await getAppConfig();
        if (configData?.webappcolor?.webappbutton) {
          setPrimaryColor(configData.webappcolor.webappbutton);
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchConfig();
  }, []);

  const validar = async () => {
    if (password !== passwordAgain) {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: "As senhas digitadas não são iguais.",
      });
      setPassword("");
      setPasswordAgain("");
      return;
    }

    try {
      setLoading(true);
      const cpf = localStorage.getItem("cpfReset");
      const payload = {
        cpf: cpf,
        addresses: [],
        password: password,
      };
      await api
        .post(`/api/customer/reset_password`, payload, {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        })
        .then(async (response: any) => {
          setLoading(false);
          const data = response.data;
          if (!data || !data.success) {
            Swal.fire({
              icon: "error",
              title: "Erro",
              text: "Erro ao atualizar a senha, tente novamente!",
            });
            return;
          }

          // MENSAGEM DE SUCESSO ANTES DE REDIRECIONAR
          Swal.fire({
            icon: "success",
            title: "Sucesso!",
            text: "Sua senha foi atualizada com sucesso. Faça login para continuar.",
          }).then(() => {
            // Só navega depois que o usuário clicar no botão do modal
            navigate(`/${pluginspace_id}/auth`);
          });
        })
        .catch((err: any) => {
          setLoading(false);
          Swal.fire({
            icon: "error",
            title: "Erro",
            text: "Erro ao atualizar a senha, tente novamente!",
          });
          console.log(err);
        });
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  return (
    <>
      {loading ? (
        <div className="loading-container" style={{ backgroundColor: "#FFF" }}>
          <Loading type="spinningBubbles" color="#FFF" width={64} height={64} />
        </div>
      ) : (
        <div className="content-main">
          {/* Botão de Voltar Padronizado */}
          <button className="btn-back" onClick={() => navigate(-1)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="15 18 9 12 15 6"></polyline>
            </svg>
            Voltar
          </button>

          <div className="validate-image">
            <img src={imageEmail} alt="Logo" />
          </div>

          <div className="validate-header">
            <h1 style={{ color: primaryColor }}>Criar nova senha</h1>
            <span>Agora você pode criar uma nova senha para a sua conta!</span>
          </div>

          <div className="content-inputs">
            {/* Nova senha */}
            <div className="input-group">
              <div className="input-header">
                <label>Nova senha:</label>
              </div>
              <input
                className="myinput"
                type="password"
                placeholder="******"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
              />
            </div>

            {/* Repetir Nova Senha */}
            <div className="input-group">
              <div className="input-header">
                <label>Repita a nova senha:</label>
              </div>
              <input
                className="myinput"
                type="password"
                placeholder="******"
                value={passwordAgain}
                onChange={(event) => setPasswordAgain(event.target.value)}
              />
            </div>

            <button
              className="btn-primary"
              style={{ background: primaryColor, marginTop: "1rem" }}
              onClick={() => validar()}
            >
              Atualizar senha
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export { ResetPassword };
